import theme from "@/theme";

export const styles = {
  modal: {
    position: "absolute",
    top: "80px",
    left: "50%",
    transform: "translate(-50%, 0)",
    width: "100%",
    maxWidth: "796px",
    bgcolor: theme.palette.custom.mainWhite,
    boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
    padding: "1.25rem",
    paddingTop: "1.25rem",
    borderRadius: "1.5rem",
  },
  title: {
    marginBottom: "1.5rem",
    padding: 0,
    textAlign: "center",
    fontSize: "1.25rem",
  },
  reasonValueInput: {
    maxWidth: "26.5rem",
    paddingLeft: "0.5rem",
    justifyContent: "space-between",
    borderRadius: "0.5rem",
    "& .MuiFormControlLabel-label": {
      fontSize: "1rem !important",
      fontWeight: 500,
    },
    "&:hover": {
      bgcolor: theme.palette.custom.blueGray100,
    },
  },
  nextStepButton: {
    marginTop: "3.25rem",
    width: "100%",
    borderRadius: "1.75rem",
    padding: "18px 0px",
    fontSize: "1rem",
    textTransform: "none",
    bgcolor: theme.palette.custom.mainBlue,
    color: theme.palette.custom.mainWhite,
    "&:disabled": {
      bgcolor: theme.palette.custom.mainBlueDisable,
      color: theme.palette.custom.mainWhite,
    },
  },
  reasonInput: {
    width: "100%",
    padding: "0px 0px",
    fontSize: "1rem",
    textTransform: "none",
    bgcolor: theme.palette.custom.mainWhite,
    color: theme.palette.custom.mainBlack,
    "& .MuiOutlinedInput-root": {
      borderRadius: "1.5rem",
      fontSize: "1rem",
      margin: 0,
    },
  },
};
